import { useMutation } from '@tanstack/react-query';

import { updateOperationInfoAccuracy } from '@/api/operation';

export const useUpdateOperationInfoAccuracy = ({
  onSuccess,
}: Readonly<{
  onSuccess?: () => void;
}>) => {
  const { mutate, isPending, error, reset } = useMutation({
    mutationFn: updateOperationInfoAccuracy,
    onSuccess,
  });

  return {
    mutate,
    isPending,
    error,
    reset,
  };
};
